// Misc
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';

// Atoms
import EventListener from 'react-event-listener';
import Link, { LinkMenuItem } from 'atoms/Link';
import Hidden from 'material-ui/Hidden';
import IconButton from 'material-ui/IconButton';
import Menu from 'material-ui/Menu';
import Svg from 'atoms/Svg';
import Container from 'atoms/Container';

// Icons
import MoreVertIcon from 'material-ui-icons/MoreVert';
import logoSymbol from 'assets/icons/logo.svg';

// Styles
import styles from './styles';

const mainDomain = window.location.hostname;

const menuLinks = [
  { to: '/features', labelDesktop: 'Features', labelMobile: 'Features' },
  { to: '//indemandly.com/register', external: true, labelDesktop: 'Sign up', labelMobile: 'Sign up' },
  { to: `//indemandly.com/login`, external: true, labelDesktop: 'Log in →', labelMobile: 'Log in' },

];

@withStyles(styles)
export default class Header extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    activeMenuLink: PropTypes.string,
  };

  state = {
    mobileMenuAnchorEl: undefined,
    mobileMenuOpen: false,
    withShadow: false
  };

  componentDidMount() {
    this.handleScroll();
  }

  componentWillReceiveProps() {
    this.handleScroll();
  }

  handleMobileMenuClick = (ev) => {
    this.setState({
      mobileMenuAnchorEl: ev.currentTarget,
      mobileMenuOpen: true
    });
  };

  handleMobileMenuClose = () => {
    this.setState({ mobileMenuOpen: false });
  };

  handleScroll = () => {
    const { withShadow } = this.state;
    const nextWithShadow = window.pageYOffset > 0;
    if (withShadow !== nextWithShadow) {
      this.setState({ withShadow: nextWithShadow });
    }
  };

  renderDesktopMenu() {
    const { classes, activeMenuLink } = this.props;
    return (
      <nav className={classes.desktopMenu}>
        { menuLinks.map(menuLink => (
          <Link
            key={menuLink.to}
            to={menuLink.to}
            external={menuLink.external}
            className={classNames({
              [classes.activeDesktopMenuLink]: activeMenuLink === menuLink.to
            })}
          >
            { menuLink.labelDesktop }
          </Link>
        )) }
      </nav>
    );
  }

  renderMobileMenu() {
    const { classes } = this.props;
    const { mobileMenuOpen, mobileMenuAnchorEl } = this.state;
    return (
      <nav>
        <IconButton
          className={classes.mobileMenuButton}
          onClick={this.handleMobileMenuClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          open={mobileMenuOpen}
          anchorEl={mobileMenuAnchorEl}
          onRequestClose={this.handleMobileMenuClose}
        >
          { menuLinks.map(menuLink => (
            <LinkMenuItem
              key={menuLink.to}
              to={menuLink.to}
              external={menuLink.external}
            >
              { menuLink.labelMobile }
            </LinkMenuItem>
          )) }
        </Menu>
      </nav>
    );
  }

  render() {
    const { classes } = this.props;
    const { withShadow } = this.state;
    const cx = classNames(classes.root, {
      [classes.rootWithShadow]: withShadow
    });

    return (
      <div>
        <EventListener
          target="window"
          onScroll={this.handleScroll}
        />
        <div className={classes.placeholder} />
        <header className={cx}>
          <Container>
            <div className={classes.rootInner}>
              <div className={classes.logoContainer}>
                <Link to="/">
                  <Svg symbol={logoSymbol} className={classes.logo} />
                </Link>
              </div>

              <Hidden smDown>
                { this.renderDesktopMenu() }
              </Hidden>

              <Hidden mdUp>
                { this.renderMobileMenu() }
              </Hidden>
            </div>
          </Container>
        </header>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js